module.exports = __webpack_public_path__ + "a8379e0e5571145abf4052784ce52bb4.png";